<template>
  <div class="tune-widget-bottombar">
      <div class="tune-widget-bottombar-1"><a class="bottom-link" href="https://www.google.com/maps/place/RICA+Engineering/@52.0145668,4.2982899,17z/data=!3m1!4b1!4m5!3m4!1s0x47c5b411ac7f6df5:0xeee86a15d93fe189!8m2!3d52.0145635!4d4.3004839" target="_blank">Klopperman 35-37, Wateringen</a></div>
      <div class="tune-widget-bottombar-2"><a class="bottom-link" href="mailto:info@rica.nl" target="_blank">info@rica.nl</a></div>
      <div class="tune-widget-bottombar-2"><a class="bottom-link" href="tel://+31 174 226 807" target="_blank">+31 174 226 807</a></div>
      <div class="tune-widget-bottombar-1"><a class="bottom-link" href="https://rica.nl/locations" target="_blank">rica.nl/locations</a></div>
  </div>
</template>

<script>
export default {

}
</script>
